module.exports = __webpack_public_path__ + "img/cvs-basic-back.00878739.svg";